// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ErrorUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/ErrorUtils.bs.js";

function fromString(m) {
  switch (m) {
    case "ab_modification" :
        return /* AB */0;
    case "simple_modification" :
        return /* Simple */1;
    default:
      return ErrorUtils$Catalyst.raiseError("CampaignModification.re", "Invalid Modification", m);
  }
}

function to_string(m) {
  if (m) {
    return "Simple";
  } else {
    return "Experiment";
  }
}

export {
  fromString ,
  to_string ,
  
}
/* No side effect */
